import { graphql, useStaticQuery } from 'gatsby';

const usePostPreviewsByCategory = ({ resourceType = '', categorySlug = '' } = {}) => {
  const data = useStaticQuery(graphql`
    query {
      allWpPost(
        filter: {
          categories: {
            nodes: {
              elemMatch: {
                name: { nin: ["Uncategorized", "Uncategorised"] }
              }
            }
          }
        }
        sort: { fields: date, order: DESC }
      ) {
        nodes {
          ...PostPreview
          id
          slug
          categories {
            nodes {
              name
              slug
              uri
            }
          }
          resourcePostItem {
            resourcePostItem {
              city: category
            }
          }
        }
      }
    }
  `);

  let allPosts = data?.allWpPost?.nodes || [];

  if (resourceType?.length > 0) {
    allPosts = allPosts.filter(
      (p) => p?.resourceTypes?.nodes?.some(({ slug }) => slug === resourceType)
    );
  }

  if (categorySlug?.length > 0) {
    allPosts = allPosts.filter(
      (p) => p?.categories?.nodes?.some(({ slug }) => slug === categorySlug)
    );
  }

  return allPosts;
};

export default usePostPreviewsByCategory;